import Page from 'flarum/common/components/Page';
import SiteSidebar from './SiteSidebar';
import { icon } from './ui';
const rules = [['01', 'Konto i bezpieczeństwo', ['Jedna osoba może korzystać wyłącznie ze swoich kont.', 'Nie udostępniaj hasła ani dostępu do NovaID.', 'Podszywanie się pod innych użytkowników jest zabronione.']], ['02', 'Rozgrywka', ['Szanuj innych graczy i nie utrudniaj im celowo rozgrywki.', 'Zakazane są cheaty, exploity, makra i wykorzystywanie błędów.', 'Znaleziony błąd zgłoś administracji zamiast czerpać z niego korzyści.']], ['03', 'Komunikacja', ['Zakazane są groźby, nękanie, spam oraz treści dyskryminujące.', 'Dbaj o kulturę wypowiedzi na serwerze, forum i Discordzie.', 'Polecenia administracji dotyczące porządku należy wykonywać.']], ['04', 'Kary i odwołania', ['Administracja dobiera karę do wagi i historii przewinień.', 'Od kary można odwołać się w odpowiednim dziale forum.', 'Próba obchodzenia kary może spowodować jej przedłużenie.']]];
export default class RulesPage extends Page {
  oncreate() {
    window.scrollTo(0, 0);
  }
  view() {
    return m("div", {
      className: "NtRulesPage"
    }, m("div", {
      className: "container NtSubpageLayout"
    }, m(SiteSidebar, null), m("main", null, m("header", {
      className: "NtPageHeading"
    }, m("small", null, "ZASADY SPO\u0141ECZNO\u015ACI"), m("h1", null, "Regulamin NovaTruck & RP"), m("p", null, "Najwa\u017Cniejsze zasady obowi\u0105zuj\u0105ce w ca\u0142ym ekosystemie projektu.")), m("div", {
      className: "NtRulesIntro"
    }, icon('fas fa-info-circle'), m("p", null, "Do\u0142\u0105czaj\u0105c do spo\u0142eczno\u015Bci, akceptujesz regulamin. Nieznajomo\u015B\u0107 zasad nie zwalnia z odpowiedzialno\u015Bci.")), m("div", {
      className: "NtRulesList"
    }, rules.map((_ref, index) => {
      let [number, title, entries] = _ref;
      return m("section", {
        style: {
          '--delay': `${index * 65}ms`
        }
      }, m("span", null, number), m("div", null, m("h2", null, title), m("ul", null, entries.map(entry => m("li", null, entry)))));
    })), m("p", {
      className: "NtRulesFoot"
    }, "Administracja mo\u017Ce aktualizowa\u0107 regulamin wraz z rozwojem projektu. Data ostatniej aktualizacji: 9 wrze\u015Bnia 2026."))));
  }
}
flarum.reg.add('novatruck-theme', 'forum/components/RulesPage', RulesPage);